import script from "./MyIssues.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyIssues.vue?vue&type=script&lang=ts&setup=true"

import "./MyIssues.vue?vue&type=style&index=0&id=72e8881b&lang=less&scoped=true"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e8881b"]])

export default __exports__